import { SocialMediaAccount } from 'state/submissions'
import { COUNTRY_ENUM, FollowerTierOption, PLATFORM_ENUM } from 'services/api/constants'
import i18n from '../config/i18n'

type PlatformDisplayType = Partial<Record<PLATFORM_ENUM, string>>

export const PLATFORM_REDIRECT_URL: PlatformDisplayType = {
    [PLATFORM_ENUM.IG]: 'https://instagram.com/',
    [PLATFORM_ENUM.FB]: 'https://facebook.com/',
    [PLATFORM_ENUM.TIKTOK]: 'https://www.tiktok.com/@',
    [PLATFORM_ENUM.TWITTER]: 'https://twitter.com/',
    [PLATFORM_ENUM.YOUTUBE]: 'https://www.youtube.com/@',
    [PLATFORM_ENUM.XIAOHONGSHU]: 'https://www.xiaohongshu.com/search_result?keyword=',
    [PLATFORM_ENUM.OTHER]: '',
}

export const PLATFORM_DISPLAY_NAME: PlatformDisplayType = {
    [PLATFORM_ENUM.IG]: i18n.t('socialMedia.platform.IG', 'IG'),
    [PLATFORM_ENUM.FB]: i18n.t('socialMedia.platform.FB', 'FB'),
    [PLATFORM_ENUM.TIKTOK]: i18n.t('socialMedia.platform.TikTok', 'TikTok'),
    [PLATFORM_ENUM.TWITTER]: i18n.t('socialMedia.platform.Twitter', 'Twitter'),
    [PLATFORM_ENUM.YOUTUBE]: i18n.t('socialMedia.platform.Youtube', 'Youtube'),
    [PLATFORM_ENUM.XIAOHONGSHU]: i18n.t('socialMedia.platform.Xiaohongshu', 'Xiaohongshu'),
    [PLATFORM_ENUM.OTHER]: i18n.t('general.option.others', 'Others'),
}

const NUMBER_SYMBOL = ['', 'k', 'M']
const NUMBER_SYMBOL_ID = ['', 'k', 'jt']

export function abbreviateNumber(value: number | null, country?: COUNTRY_ENUM): string | null {
    if (value === null || value === 0) return null
    const tier = Math.floor(Math.log10(value) / 3)

    if (tier === 0) return value.toString()
    const scale = Math.pow(10, tier * 3)
    return Math.floor(value / scale) + (country === COUNTRY_ENUM.ID ? NUMBER_SYMBOL_ID[tier] : NUMBER_SYMBOL[tier])
}

export const parseFollowerOption = (option: FollowerTierOption, country?: COUNTRY_ENUM): string =>
    option.max == null
        ? i18n.t('', 'Above') + ' ' + abbreviateNumber(option.min, country)
        : option.min == 0
          ? '0 - ' + abbreviateNumber(option.max, country)
          : abbreviateNumber(option.min, country) + ' - ' + abbreviateNumber(option.max, country)

// TODO: change params to optional, and check inside this function. so we can remove params check outside
export const getFollowerTierDisplay = (
    social_media_account: SocialMediaAccount,
    country: COUNTRY_ENUM,
    followerTierOptions: FollowerTierOption[],
    showPlatformName = false,
): string => {
    const option = followerTierOptions.find(option => option.id == social_media_account.follower_number_tier)
    if (!social_media_account.follower_number_tier && !option) {
        return ''
    }
    const followerRange = country && option ? parseFollowerOption(option, country) : '0 - ?'
    return option
        ? followerRange + (showPlatformName ? ' (' + PLATFORM_DISPLAY_NAME[social_media_account.platform] + ')' : '')
        : ''
}
